export { default } from './DeleteDialog.container';
